import { render, staticRenderFns } from "./ClaioSchemaTool.vue?vue&type=template&id=3119a96e&scoped=true&"
import script from "./ClaioSchemaTool.vue?vue&type=script&lang=ts&"
export * from "./ClaioSchemaTool.vue?vue&type=script&lang=ts&"
import style0 from "./ClaioSchemaTool.vue?vue&type=style&index=0&id=3119a96e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3119a96e",
  null
  
)

export default component.exports